var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3732_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0923 32.9794H18.5613C18.2479 32.9761 17.9427 32.8849 17.6841 32.7174C17.4256 32.5499 17.2254 32.3135 17.109 32.0382C16.9892 31.7533 16.9675 31.4398 17.0471 31.1425C17.1266 30.8452 17.3033 30.5793 17.552 30.3826L24.0872 25.1202C24.1074 25.1043 24.1238 25.0843 24.1351 25.0618C24.1464 25.0392 24.1523 25.0146 24.1525 24.9897C24.1534 24.9646 24.1479 24.9397 24.1365 24.917C24.1252 24.8943 24.1083 24.8744 24.0872 24.8592L17.552 19.5968C17.3042 19.3995 17.1282 19.1335 17.0487 18.8365C16.9692 18.5394 16.9903 18.2263 17.109 17.9412C17.2238 17.6648 17.4235 17.4274 17.6824 17.2597C17.9413 17.0919 18.2475 17.0014 18.5613 17H30.0923C30.3331 17 30.5639 17.0905 30.7341 17.2515C30.9044 17.4126 31 17.631 31 17.8587C31 18.0865 30.9044 18.3049 30.7341 18.466C30.5639 18.627 30.3331 18.7175 30.0923 18.7175H19.7231C19.6891 18.7153 19.6551 18.7226 19.6254 18.7384C19.5958 18.7543 19.5716 18.7781 19.5561 18.8068C19.5393 18.8446 19.5374 18.8869 19.5507 18.926C19.564 18.9651 19.5917 18.9983 19.6287 19.0198L25.6702 23.8699C25.8428 24.0073 25.9815 24.1787 26.0767 24.3721C26.1719 24.5655 26.2212 24.7763 26.2212 24.9897C26.2212 25.2031 26.1719 25.4139 26.0767 25.6073C25.9815 25.8007 25.8428 25.9721 25.6702 26.1095L19.6287 30.9596C19.5917 30.9811 19.564 31.0143 19.5507 31.0534C19.5374 31.0925 19.5393 31.1348 19.5561 31.1726C19.5683 31.2052 19.5909 31.2333 19.6209 31.253C19.6509 31.2727 19.6866 31.2831 19.7231 31.2825H30.0923C30.3331 31.2825 30.5639 31.373 30.7341 31.534C30.9044 31.6951 31 31.9135 31 32.1413C31 32.369 30.9044 32.5874 30.7341 32.7485C30.5639 32.9095 30.3331 33 30.0923 33V32.9794Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3732_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon10);
export default __webpack_public_path__ + "static/media/nav_icon_10.62394c641f641c3607dcf189732673c8.svg";
export { ForwardRef as ReactComponent };